import update from "immutability-helper";
import { useCallback, useState, useRef, useEffect } from "react";
import { useDrop } from "react-dnd";
import { Table } from "./Table.js";
import { ItemTypes } from "./ItemTypes.js";
import { snapToGrid as doSnapToGrid } from "./snapToGrid.js";
import DraggableTable from "./DraggableTable.js";
import { OrangeButton, CloseIcon } from "../components/DefaultImports.js";
import GridItems from "./GridItems.js";
import styled from "styled-components";
import {
  Nav,
  Card,
  Button,
  Row,
  Col,
  Modal,
  Container,
  Form,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import {
  createTables,
  fetchTables,
  createPlaceOfTable,
  fetchPlaceOfTable,
  bulkUpdateTables,
  fetchTableConnections,
  updateTableConnections,
  fetchRestaurantDetails,
} from "../actions/restaurantActions";
import { snapTablePosition } from "./TableSnapHelper.js";

import { api } from "../App";

const SnapGhost = styled.div`
  position: absolute;
  left: ${({ left }) => Number(left) || 0}px;
  top: ${({ top }) => Number(top) || 0}px;
  width: ${({ width }) => Number(width) || 50}px;
  height: ${({ height }) => Number(height) || 50}px;
  border: 2px solid rgba(238, 117, 76, 0.85);
  background: rgba(238, 117, 76, 0.1);
  box-shadow: 0 0 0 4px rgba(238, 117, 76, 0.12);
  border-radius: 8px;
  pointer-events: none;
  z-index: 50;
`;

const SnapTargetGuide = styled.div`
  position: absolute;
  left: ${({ left }) => Number(left) || 0}px;
  top: ${({ top }) => Number(top) || 0}px;
  width: ${({ width }) => Number(width) || 50}px;
  height: ${({ height }) => Number(height) || 50}px;
  border: 1px dashed rgba(153, 176, 173, 0.95);
  background: rgba(153, 176, 173, 0.08);
  border-radius: 8px;
  pointer-events: none;
  z-index: 45;
`;

const StyledDiv = styled.div`
  width: 100%;
  max-height: 400px;
  overflow: auto;
  border-radius: 0 0 5px 5px;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
`;

const StyledDivInside = styled.div`
  width: 750px;
  height: 400px;
  position: relative;
  background-color: white;
  background-image:
    linear-gradient(to right, rgba(0, 0, 0, 0.04) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.04) 1px, transparent 1px);
  background-size: 150px 150px;
`;

const StyledCard = styled(Card)`
  margin: 10px 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0 0 5px 5px;
  overflow: hidden;
`;

const CardTop = styled.div`
  padding: 5px;
  background-color: #faf6e9;
  position: relative;
`;

const CardMenuTop = styled.div`
  height: auto;
  padding: 5px 5px 0 5px;
  background-color: #faf6e9;
  position: relative;
`;

const CardBot = styled.div`
  height: 100px;
  background-color: white;
  position: relative;
`;

const CardBotGrid = styled.div`
  height: 35px;
  background-color: #faf6e9;
  width: 100%;
  position: relative;
  padding: 5px;
`;

const StyledSelect = styled.select`
  width: 85%;
  height: 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const AddFilterBox = styled.button`
  width: 100%;
  padding: 12px 14px;
  border: 1px dashed #99b0ad;
  border-radius: 8px;
  background: #ffffff;
  color: #99b0ad;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.15s ease;

  &:hover {
    border-color: #ee754c;
    color: #ee754c;
  }
`;

const BulkTableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

const normalizeAutoSetTables = (value) => {
  if (value === false || value === 0 || value === "false" || value === "0") {
    return false;
  }

  return true;
};

export const Grid = ({
  snapToGrid,
  selectedItem,
  setSelectedItem,
  setWidth,
  setHeight,
  all_tables,
  setDraggingItem,
  draggingItem,
  restaurant_id,
}) => {
  const dispatch = useDispatch();

  const [selectedPlace, setSelectedPlace] = useState(false);
  const [selectedSeparator, setSelectedSeparator] = useState("Tables");
  const [tabOrPills, setTabOrPills] = useState("tabs");
  const [topDistance, setTopDistance] = useState("");
  const [isReady, setIsReady] = useState(false);

  const containerRef = useRef(null);
  const insideContainerRef = useRef(null);
  const MenuRef = useRef(null);

  const [tables, setTables] = useState([]);

  const restaurantZones = useSelector((state) => state.restaurantZones);
  const { zones = [] } = restaurantZones;

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const tableConnectionsState = useSelector((state) => state.tableConnections);
  const { connections: tableConnections = [] } = tableConnectionsState;

  const [currentAutoSetTables, setCurrentAutoSetTables] = useState(true);
  const [draftAutoSetTables, setDraftAutoSetTables] = useState(true);

  const [canCreate, setCanCreate] = useState(false);

  const [objects, setObjects] = useState([
    {
      height: 50,
      id: 246,
      isPlaced: false,
      left: 0,
      number_of_seats: "3",
      place_of_table: 7,
      restaurant: 1,
      round_or_square: "square",
      table_name: "1",
      table_number: "1",
      top: 0,
      type: "table",
      width: 50,
    },
  ]);

  const [showCreateTables, setShowCreateTables] = useState(false);
  const [numTablesToAdd, setNumTablesToAdd] = useState("");
  const [numSeatsPerTable, setNumSeatsPerTable] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  const [showDeleteTables, setShowDeleteTables] = useState(false);
  const [numTablesToDelete, setNumTablesToDelete] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const [showCreateZone, setShowCreateZone] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const [isCreatingZone, setIsCreatingZone] = useState(false);

  const [showDeleteZone, setShowDeleteZone] = useState(false);
  const [isDeletingZone, setIsDeletingZone] = useState(false);

  const [showBulkEditor, setShowBulkEditor] = useState(false);
  const [bulkEditPlace, setBulkEditPlace] = useState(null);
  const [bulkRows, setBulkRows] = useState([]);
  const [isBulkEditorSaving, setIsBulkEditorSaving] = useState(false);

  const [isConnectionConfigMode, setIsConnectionConfigMode] = useState(false);
  const [selectedConnectionIds, setSelectedConnectionIds] = useState([]);
  const [pendingConnectionChanges, setPendingConnectionChanges] = useState({});
  const [isBulkDirty, setIsBulkDirty] = useState(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);

  const [modalAddCount, setModalAddCount] = useState("");
  const [modalAddSeats, setModalAddSeats] = useState("");
  const [modalDelCount, setModalDelCount] = useState("");
  const [modalIsCreating, setModalIsCreating] = useState(false);
  const [modalIsDeleting, setModalIsDeleting] = useState(false);

  const [deletingRowId, setDeletingRowId] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState({
    show: false,
    tableId: null,
    label: "",
  });
  const [snapPreview, setSnapPreview] = useState(null);

  const isAutoSetTablesDirty =
    normalizeAutoSetTables(draftAutoSetTables) !==
    normalizeAutoSetTables(currentAutoSetTables);

  const hasUnsavedBulkModalChanges =
    isBulkDirty ||
    isAutoSetTablesDirty ||
    Object.keys(pendingConnectionChanges).length > 0;

  useEffect(() => {
    const clearSnapPreview = () => {
      setSnapPreview(null);
    };

    window.addEventListener("mouseup", clearSnapPreview);
    window.addEventListener("mouseleave", clearSnapPreview);

    return () => {
      window.removeEventListener("mouseup", clearSnapPreview);
      window.removeEventListener("mouseleave", clearSnapPreview);
    };
  }, []);

  useEffect(() => {
    if (restaurants?.id) {
      dispatch(fetchTableConnections(restaurants.id));
    }
  }, [dispatch, restaurants?.id]);

  useEffect(() => {
    setCurrentAutoSetTables(
      normalizeAutoSetTables(restaurants?.auto_set_tables),
    );
  }, [restaurants?.auto_set_tables]);

  useEffect(() => {
    setCanCreate(
      !!restaurants?.id &&
        !!selectedPlace &&
        Number(numTablesToAdd) > 0 &&
        Number(numSeatsPerTable) > 0,
    );
  }, [numTablesToAdd, numSeatsPerTable, selectedPlace, restaurants?.id]);

  useEffect(() => {
    setTables(all_tables || []);
  }, [all_tables]);

  useEffect(() => {
    if (zones.length > 0 && !selectedPlace) {
      setSelectedPlace(zones[0].id);
    }
  }, [zones, selectedPlace]);

  useEffect(() => {
    if (selectedItem?.id) {
      const foundTable = tables.find((t) => t.id === selectedItem.id);
      if (foundTable) {
        console.log(
          `Selected Table ID: ${foundTable.id}, Width: ${foundTable.width}, Height: ${foundTable.height}`,
        );
      }
    }
  }, [selectedItem, tables]);

  useEffect(() => {
    if (showBulkEditor && bulkEditPlace) {
      const rows = (tables || [])
        .filter((t) => t.place_of_table === bulkEditPlace)
        .sort((a, b) => Number(a.table_number) - Number(b.table_number));

      setBulkRows(rows.map((r) => ({ ...r })));
    }
  }, [tables, showBulkEditor, bulkEditPlace]);

  const getTableLabelById = useCallback(
    (tableId) => {
      const table = (tables || []).find(
        (t) => Number(t.id) === Number(tableId),
      );
      if (!table) return `#${tableId}`;

      return table.table_name || table.table_number || `#${table.id}`;
    },
    [tables],
  );

  const getConnectedTableIds = useCallback(
    (tableId) => {
      if (!tableId || !Array.isArray(tableConnections)) {
        return [];
      }

      return tableConnections
        .filter((connection) => {
          return (
            connection.is_active &&
            (connection.table_a === tableId || connection.table_b === tableId)
          );
        })
        .map((connection) => {
          return connection.table_a === tableId
            ? connection.table_b
            : connection.table_a;
        });
    },
    [tableConnections],
  );

  const getEffectiveConnectedTableIds = useCallback(
    (tableId, draftMap = pendingConnectionChanges) => {
      if (!tableId) return [];

      const normalizedTableId = Number(tableId);
      const hasOwn = Object.prototype.hasOwnProperty.call(
        draftMap,
        normalizedTableId,
      );

      const baseIds = hasOwn
        ? draftMap[normalizedTableId] || []
        : getConnectedTableIds(normalizedTableId);

      const result = new Set(baseIds.map(Number));

      Object.entries(draftMap).forEach(([sourceIdRaw, sourceConnectedIds]) => {
        const sourceId = Number(sourceIdRaw);

        if (sourceId === normalizedTableId) return;

        const sourceHasThisTable = (sourceConnectedIds || [])
          .map(Number)
          .includes(normalizedTableId);

        if (sourceHasThisTable) {
          result.add(sourceId);
        } else {
          result.delete(sourceId);
        }
      });

      result.delete(normalizedTableId);

      return Array.from(result);
    },
    [pendingConnectionChanges, getConnectedTableIds],
  );

  const getConnectedTableNames = useCallback(
    (tableId) => {
      const ids = getEffectiveConnectedTableIds(tableId);

      if (!ids.length) return "Nenhuma";

      return ids.map((id) => getTableLabelById(id)).join(", ");
    },
    [getEffectiveConnectedTableIds, getTableLabelById],
  );

  const selectItem = (value) => setSelectedItem(value);

  const startEditingConnections = useCallback(
    (table) => {
      if (!table?.id) return;

      const nextDraftMap = { ...pendingConnectionChanges };

      if (selectedItem?.id && isConnectionConfigMode) {
        nextDraftMap[selectedItem.id] = selectedConnectionIds;
      }

      setPendingConnectionChanges(nextDraftMap);
      selectItem(table);
      setSelectedConnectionIds(
        getEffectiveConnectedTableIds(table.id, nextDraftMap),
      );
      setIsConnectionConfigMode(true);
    },
    [
      pendingConnectionChanges,
      selectedItem,
      selectedConnectionIds,
      isConnectionConfigMode,
      getEffectiveConnectedTableIds,
    ],
  );

  const handleStartGroupConfig = () => {
    const selectedTableInCurrentRoom = bulkRows.find(
      (row) => Number(row.id) === Number(selectedItem?.id),
    );

    const tableToEdit = selectedTableInCurrentRoom || bulkRows[0];

    if (tableToEdit) {
      startEditingConnections(tableToEdit);
    }
  };

  const toggleConnectionTable = useCallback(
    (tableId) => {
      if (!selectedItem?.id) return;

      const sourceId = Number(selectedItem.id);
      const targetId = Number(tableId);

      setPendingConnectionChanges((previousDraftMap) => {
        const currentSourceIds = getEffectiveConnectedTableIds(
          sourceId,
          previousDraftMap,
        );

        const nextSourceIds = currentSourceIds.includes(targetId)
          ? currentSourceIds.filter((id) => Number(id) !== targetId)
          : [...currentSourceIds, targetId];

        const nextDraftMap = {
          ...previousDraftMap,
          [sourceId]: nextSourceIds,
        };

        const currentTargetIds = getEffectiveConnectedTableIds(
          targetId,
          previousDraftMap,
        );

        if (nextSourceIds.includes(targetId)) {
          nextDraftMap[targetId] = Array.from(
            new Set([...currentTargetIds, sourceId]),
          ).filter((id) => Number(id) !== targetId);
        } else {
          nextDraftMap[targetId] = currentTargetIds.filter(
            (id) => Number(id) !== sourceId,
          );
        }

        setSelectedConnectionIds(nextSourceIds);
        return nextDraftMap;
      });
    },
    [selectedItem, getEffectiveConnectedTableIds],
  );

  const resetBulkEditorDrafts = () => {
    setIsBulkDirty(false);
    setPendingConnectionChanges({});
    setSelectedConnectionIds([]);
    setIsConnectionConfigMode(false);
  };

  const forceCloseBulkEditor = () => {
    setShowUnsavedChangesModal(false);
    setShowBulkEditor(false);
    resetBulkEditorDrafts();
  };

  const requestCloseBulkEditor = () => {
    if (hasUnsavedBulkModalChanges) {
      setShowUnsavedChangesModal(true);
      return;
    }

    forceCloseBulkEditor();
  };

  const moveTable = useCallback((id, left, top, state = "tableOn") => {
    setTables((tables) =>
      tables.map((table) => {
        if (String(table.id) !== String(id)) return table;

        const shouldUnplace = state === "tableOff" || state === "reset";

        return {
          ...table,
          left: shouldUnplace ? 20 : left,
          top: shouldUnplace ? 20 : top,
          isPlaced: !shouldUnplace,
        };
      }),
    );
  }, []);
  const calculateSnappedDropPosition = useCallback(
    (item, monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset();

      if (!delta) {
        return null;
      }

      let left = Math.round(Number(item.left || 0) + delta.x);
      let top = Math.round(Number(item.top || 0) + delta.y);

      if (snapToGrid) {
        [left, top] = doSnapToGrid(left, top);
      }

      const movingTable =
        (tables || []).find((table) => String(table.id) === String(item.id)) ||
        item;

      const movingPlace = movingTable?.place_of_table || selectedPlace;

      const snapTables = (tables || []).filter((table) => {
        if (!table) return false;
        if (String(table.id) === String(item.id)) return false;

        const isPlaced =
          table.isPlaced === true ||
          table.isPlaced === 1 ||
          table.isPlaced === "1" ||
          table.isPlaced === "true";

        if (!isPlaced) return false;

        const sameRoom =
          String(table.place_of_table) === String(movingPlace) ||
          String(table.place_of_table) === String(selectedPlace);

        return sameRoom;
      });

      const width = Number(movingTable?.width) || Number(item?.width) || 50;
      const height = Number(movingTable?.height) || Number(item?.height) || 50;

      const snapResult = snapTablePosition(
        snapTables,
        item.id,
        left,
        top,
        width,
        height,
        {
          snapDistance: 28,
          centerSnapDistance: 14,
          snapGap: 3,
          overlapTolerance: 45,
        },
      );

      return {
        state: item.state,
        left: snapResult.left,
        top: snapResult.top,
        width,
        height,
        didSnap: snapResult.didSnap,
        guide: snapResult.guide,
      };
    },
    [tables, selectedPlace, snapToGrid],
  );

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.TABLE,

      drop(item, monitor) {
        const canvasElement = insideContainerRef.current;

        if (!canvasElement) {
          return undefined;
        }

        const movingTable =
          (tables || []).find(
            (table) => String(table.id) === String(item.id),
          ) || item;

        const safeWidth =
          Number(movingTable?.width) || Number(item?.width) || 50;

        const safeHeight =
          Number(movingTable?.height) || Number(item?.height) || 50;

        const canvasRect = canvasElement.getBoundingClientRect();

        const sourceClientOffset = monitor.getSourceClientOffset();
        const clientOffset = monitor.getClientOffset();
        const delta = monitor.getDifferenceFromInitialOffset();

        let left = 0;
        let top = 0;

        if (sourceClientOffset) {
          left = Math.round(sourceClientOffset.x - canvasRect.left);
          top = Math.round(sourceClientOffset.y - canvasRect.top);
        } else if (clientOffset) {
          left = Math.round(clientOffset.x - canvasRect.left - safeWidth / 2);
          top = Math.round(clientOffset.y - canvasRect.top - safeHeight / 2);
        } else if (delta) {
          left = Math.round(Number(item.left || 0) + delta.x);
          top = Math.round(Number(item.top || 0) + delta.y);
        } else {
          return undefined;
        }

        left = clamp(left, 0, CANVAS_WIDTH - safeWidth);
        top = clamp(top, 0, CANVAS_HEIGHT - safeHeight);

        if (snapToGrid) {
          [left, top] = doSnapToGrid(left, top);
        }

        const snapTables = (tables || []).filter((table) => {
          if (!table) return false;
          if (String(table.id) === String(item.id)) return false;
          return isTablePlaced(table);
        });

        const snapResult = snapTablePosition(
          snapTables,
          item.id,
          left,
          top,
          safeWidth,
          safeHeight,
          {
            snapDistance: 24,
            centerSnapDistance: 12,
            snapGap: 3,
            overlapTolerance: 35,
          },
        );

        const finalLeft = clamp(
          Math.round(snapResult.left),
          0,
          CANVAS_WIDTH - safeWidth,
        );

        const finalTop = clamp(
          Math.round(snapResult.top),
          0,
          CANVAS_HEIGHT - safeHeight,
        );

        // Important: force it into the canvas instead of preserving "tableOff"
        moveTable(item.id, finalLeft, finalTop, "tableOn");

        return undefined;
      },
    }),
    [moveTable, snapToGrid, tables],
  );

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0].contentRect.width < 297) setTabOrPills("pills");
      else setTabOrPills("tabs");
    });

    if (MenuRef.current) {
      resizeObserver.observe(MenuRef.current);
    }

    return () => {
      if (MenuRef.current) {
        resizeObserver.unobserve(MenuRef.current);
      }
    };
  }, [isReady]);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsReady(true), 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (insideContainerRef.current) {
        const rect = insideContainerRef.current.getBoundingClientRect();
        const top = rect.top;
        setTopDistance(top);
      }
    };

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target) {
          const rect = entry.target.getBoundingClientRect();
          const top = rect.top;
          setTopDistance(top);
        }
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
      window.addEventListener("scroll", handleScroll);

      if (typeof containerRef.current.addEventListener === "function") {
        containerRef.current.addEventListener("scroll", handleScroll);
      }
    }

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("scroll", handleScroll);

      if (
        containerRef.current &&
        typeof containerRef.current.removeEventListener === "function"
      ) {
        containerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [containerRef, insideContainerRef, isReady]);

  const handleCreateTables = async () => {
    if (!canCreate) return;

    try {
      setIsCreating(true);

      const payload = {
        place_of_table: selectedPlace,
        num_tables_to_create: Number(numTablesToAdd),
        num_seats: Number(numSeatsPerTable),
      };

      await dispatch(createTables(restaurants.id, payload));
      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));

      setShowCreateTables(false);
      setNumTablesToAdd("");
      setNumSeatsPerTable("");
    } catch (e) {
      console.error("Failed to create tables:", e);
    } finally {
      setIsCreating(false);
    }
  };

  const handleDeleteTables = async () => {
    const qty = Number(numTablesToDelete);

    if (!restaurants?.id || !selectedPlace || !qty || qty < 1) return;

    try {
      setIsDeleting(true);

      await api.delete(
        `restaurants/${restaurants.id}/zones/${selectedPlace}/delete-tables/${qty}/`,
      );

      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));

      setShowDeleteTables(false);
      setNumTablesToDelete("");
    } catch (e) {
      console.error("Failed to delete tables:", e);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCreateZone = async () => {
    if (!restaurants?.id || !zoneName?.trim()) return;

    try {
      setIsCreatingZone(true);

      const payload = {
        restaurant: restaurants.id,
        place_of_table: zoneName.trim(),
      };

      await dispatch(createPlaceOfTable(restaurants.id, payload));
      await dispatch(fetchPlaceOfTable(restaurants.id));

      setShowCreateZone(false);
      setZoneName("");
    } catch (e) {
      console.error("Failed to create zone:", e);
    } finally {
      setIsCreatingZone(false);
    }
  };

  const handleDeleteZone = async () => {
    if (!restaurants?.id || !selectedPlace) return;

    try {
      setIsDeletingZone(true);

      await api.delete(
        `restaurants/${restaurants.id}/placeoftable/${selectedPlace}/`,
      );

      setSelectedPlace(false);
      setShowDeleteZone(false);
      resetBulkEditorDrafts();

      await dispatch(fetchPlaceOfTable(restaurants.id));
      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));
    } catch (e) {
      console.error("Failed to delete zone:", e);
    } finally {
      setIsDeletingZone(false);
    }
  };

  const [isBulkSaving, setIsBulkSaving] = useState(false);

  const pickUpdateFields = (t) => {
    const u = { id: t.id };

    if (typeof t.table_name !== "undefined") u.table_name = t.table_name;
    if (typeof t.number_of_seats !== "undefined")
      u.number_of_seats = t.number_of_seats;
    if (typeof t.left !== "undefined") u.left = t.left;
    if (typeof t.top !== "undefined") u.top = t.top;
    if (typeof t.width !== "undefined") u.width = t.width;
    if (typeof t.height !== "undefined") u.height = t.height;
    if (typeof t.isPlaced !== "undefined") u.isPlaced = !!t.isPlaced;
    if (typeof t.round_or_square !== "undefined")
      u.round_or_square = t.round_or_square;

    return u;
  };

  const handleSaveAllTables = async () => {
    if (!restaurants?.id || !Array.isArray(tables) || tables.length === 0) {
      return;
    }

    try {
      setIsBulkSaving(true);

      const updates = tables.map(pickUpdateFields);

      await dispatch(bulkUpdateTables(restaurants.id, updates));
      await dispatch(fetchTables(restaurants.id));
    } catch (e) {
      console.error("Bulk save failed:", e);
    } finally {
      setIsBulkSaving(false);
    }
  };

  const openBulkEditor = () => {
    const initialPlace = selectedPlace || (zones[0]?.id ?? null);

    setBulkEditPlace(initialPlace);

    const rows = (tables || [])
      .filter((t) => t.place_of_table === initialPlace)
      .sort((a, b) => Number(a.table_number) - Number(b.table_number));

    setBulkRows(rows.map((r) => ({ ...r })));
    setDraftAutoSetTables(normalizeAutoSetTables(currentAutoSetTables));
    setShowBulkEditor(true);
    setModalAddCount("");
    setModalAddSeats("");
    setModalDelCount("");
    resetBulkEditorDrafts();
  };

  const changeBulkRoom = (placeId) => {
    if (hasUnsavedBulkModalChanges) {
      setShowUnsavedChangesModal(true);
      return;
    }

    setBulkEditPlace(placeId);

    const rows = (tables || [])
      .filter((t) => t.place_of_table === placeId)
      .sort((a, b) => Number(a.table_number) - Number(b.table_number));

    setBulkRows(rows.map((r) => ({ ...r })));
    setModalAddCount("");
    setModalAddSeats("");
    setModalDelCount("");
    resetBulkEditorDrafts();
    setSelectedItem(null);
  };

  const onBulkRowChange = (id, field, value) => {
    setIsBulkDirty(true);

    setBulkRows((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [field]: value } : r)),
    );
  };

  const saveBulkEditor = async ({ closeAfterSave = true } = {}) => {
    if (!restaurants?.id) return;

    try {
      setIsBulkEditorSaving(true);

      const updates = bulkRows.map((r) => {
        const u = { id: r.id };

        if (typeof r.table_name !== "undefined") {
          u.table_name = r.table_name;
        }

        if (typeof r.number_of_seats !== "undefined") {
          u.number_of_seats = Number(r.number_of_seats) || 0;
        }

        if (typeof r.round_or_square !== "undefined") {
          u.round_or_square = r.round_or_square || "square";
        }

        return u;
      });

      if (updates.length > 0) {
        await dispatch(bulkUpdateTables(restaurants.id, updates));
      }

      const normalizedDraftAutoSetTables =
        normalizeAutoSetTables(draftAutoSetTables);

      if (isAutoSetTablesDirty) {
        const response = await api.patch(
          `restaurants/details/${restaurants.id}/`,
          {
            auto_set_tables: normalizedDraftAutoSetTables,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          },
        );

        const updatedRestaurant = response.data;

        setCurrentAutoSetTables(
          normalizeAutoSetTables(updatedRestaurant.auto_set_tables),
        );

        setDraftAutoSetTables(
          normalizeAutoSetTables(updatedRestaurant.auto_set_tables),
        );

        await dispatch(fetchRestaurantDetails(restaurants.id));
      }

      const connectionEntries = Object.entries(pendingConnectionChanges);

      for (const [tableId, connectedIds] of connectionEntries) {
        await dispatch(
          updateTableConnections(
            restaurants.id,
            Number(tableId),
            connectedIds.map(Number),
          ),
        );
      }

      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));

      setIsBulkDirty(false);
      setPendingConnectionChanges({});
      setSelectedConnectionIds([]);
      setShowUnsavedChangesModal(false);

      if (closeAfterSave) {
        setShowBulkEditor(false);
        setIsConnectionConfigMode(false);
      }
    } catch (e) {
      console.error("Bulk editor save failed:", e);
    } finally {
      setIsBulkEditorSaving(false);
    }
  };

  const handleDeleteSingleTable = async (tableId) => {
    if (!restaurants?.id || !tableId) return;

    try {
      setDeletingRowId(tableId);

      await api.delete(`restaurants/${restaurants.id}/tables/${tableId}/`);
      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));
    } catch (e) {
      console.error("Single table delete failed:", e);
    } finally {
      setDeletingRowId(null);
    }
  };

  const handleModalCreateTables = async () => {
    const cnt = Number(modalAddCount);
    const seats = Number(modalAddSeats);

    if (
      !restaurants?.id ||
      !bulkEditPlace ||
      !cnt ||
      cnt < 1 ||
      !seats ||
      seats < 1
    ) {
      return;
    }

    try {
      setModalIsCreating(true);

      const payload = {
        place_of_table: bulkEditPlace,
        num_tables_to_create: cnt,
        num_seats: seats,
      };

      await dispatch(createTables(restaurants.id, payload));
      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));

      setModalAddCount("");
      setModalAddSeats("");
    } catch (e) {
      console.error("Modal create failed:", e);
    } finally {
      setModalIsCreating(false);
    }
  };

  const handleModalDeleteTables = async () => {
    const qty = Number(modalDelCount);

    if (!restaurants?.id || !bulkEditPlace || !qty || qty < 1) return;

    try {
      setModalIsDeleting(true);

      await api.delete(
        `restaurants/${restaurants.id}/zones/${bulkEditPlace}/delete-tables/${qty}/`,
      );

      await dispatch(fetchTables(restaurants.id));
      await dispatch(fetchTableConnections(restaurants.id));

      setModalDelCount("");
    } catch (e) {
      console.error("Modal delete failed:", e);
    } finally {
      setModalIsDeleting(false);
    }
  };

  const tablesInSelectedZone = (tables || []).filter(
    (t) => t.place_of_table === selectedPlace,
  ).length;

  const CANVAS_WIDTH = 750;
  const CANVAS_HEIGHT = 400;

  const clamp = (value, min, max) => {
    return Math.max(min, Math.min(max, value));
  };

  const isTablePlaced = (table) => {
    return (
      table?.isPlaced === true ||
      table?.isPlaced === 1 ||
      table?.isPlaced === "1" ||
      table?.isPlaced === "true"
    );
  };

  return (
    <Container className="no-select">
      <StyledCard>
        <CardTop>
          <Row className="align-items-center">
            <Col xs={6} sm={6} md={8}></Col>
            <Col xs={6} sm={6} md={4}>
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <StyledSelect
                  value={selectedPlace || ""}
                  onChange={(e) =>
                    setSelectedPlace(parseInt(e.target.value, 10))
                  }
                >
                  {zones.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.place_of_table}
                    </option>
                  ))}
                </StyledSelect>

                <OrangeButton
                  size="sm"
                  style={{ fontSize: "0.8rem", padding: "3px 8px" }}
                  onClick={() => setShowCreateZone(true)}
                  disabled={!restaurants?.id}
                  title={
                    !restaurants?.id ? "Restaurante inválido" : "Nova sala"
                  }
                >
                  Nova sala
                </OrangeButton>

                <Button
                  variant="danger"
                  size="sm"
                  style={{ fontSize: "0.8rem", padding: "3px 8px" }}
                  onClick={() => setShowDeleteZone(true)}
                  disabled={!selectedPlace}
                  title={
                    !selectedPlace ? "Selecione uma sala" : "Eliminar sala"
                  }
                >
                  Eliminar sala
                </Button>
              </div>
            </Col>
          </Row>
        </CardTop>

        {tables && tables.length > 0 && (
          <StyledDiv ref={containerRef}>
            <StyledDivInside
              ref={(node) => {
                insideContainerRef.current = node;
                drop(node);
              }}
            >
              {snapPreview?.guide && (
                <SnapTargetGuide
                  left={snapPreview.guide.left}
                  top={snapPreview.guide.top}
                  width={snapPreview.guide.width}
                  height={snapPreview.guide.height}
                />
              )}

              {snapPreview && (
                <SnapGhost
                  left={snapPreview.left}
                  top={snapPreview.top}
                  width={snapPreview.width}
                  height={snapPreview.height}
                />
              )}

              {tables
                .filter((table) => table.place_of_table === selectedPlace)
                .map((table, index) => (
                  <DraggableTable
                    key={index}
                    id={table.id}
                    {...table}
                    selectedItem={selectedItem}
                    selectItem={selectItem}
                    tables={tables}
                    moveTable={moveTable}
                    table={table}
                  />
                ))}
            </StyledDivInside>
          </StyledDiv>
        )}

        <CardBotGrid>
          <Row>
            <Col xs={6} sm={6} md={8}></Col>
            <Col xs={6} sm={6} md={4}>
              <ActionButtons>
                <OrangeButton
                  size="sm"
                  className="mr-2"
                  style={{ fontSize: "0.8rem", padding: "3px" }}
                  onClick={handleSaveAllTables}
                  disabled={isBulkSaving || !restaurants?.id || !tables?.length}
                  title={
                    !restaurants?.id
                      ? "Restaurante inválido"
                      : "Guardar todas as mesas"
                  }
                >
                  {isBulkSaving ? "A guardar…" : "Guardar"}
                </OrangeButton>
              </ActionButtons>
            </Col>
          </Row>
        </CardBotGrid>
      </StyledCard>

      <StyledCard>
        <CardMenuTop ref={MenuRef}>
          <Row className="align-items-center">
            <Col xs={7} sm={8} md={8}>
              <Nav variant={tabOrPills} defaultActiveKey="link-0">
                <Nav.Item>
                  <Nav.Link
                    onClick={() => setSelectedSeparator("Tables")}
                    eventKey="link-0"
                  >
                    Mesa
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col xs={5} sm={4} md={4}>
              <ActionButtons style={{ alignItems: "center", flexWrap: "wrap" }}>
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: "#666",
                    background: "#faf6e9",
                    border: "1px solid #eee",
                    borderRadius: 999,
                    padding: "3px 8px",
                    whiteSpace: "nowrap",
                  }}
                  title={
                    currentAutoSetTables
                      ? "O sistema pode combinar quaisquer mesas livres."
                      : "O sistema só usa mesas individuais ou grupos configurados."
                  }
                >
                  {currentAutoSetTables
                    ? "Automático flexível"
                    : "Grupos fixos"}
                </div>

                <Button
                  variant="outline-secondary"
                  size="sm"
                  style={{ fontSize: "0.8rem", padding: "3px" }}
                  onClick={openBulkEditor}
                  disabled={!selectedPlace}
                  title={
                    !selectedPlace
                      ? "Selecione uma sala para editar"
                      : "Editar lista de mesas"
                  }
                >
                  Editar lista
                </Button>

                <OrangeButton
                  size="sm"
                  style={{ fontSize: "0.8rem", padding: "3px" }}
                  onClick={() => setShowCreateTables(true)}
                  disabled={!selectedPlace}
                  title={
                    !selectedPlace
                      ? "Selecione uma sala para criar mesas"
                      : "Adicionar mesas"
                  }
                >
                  Adicionar mesas
                </OrangeButton>
              </ActionButtons>
            </Col>
          </Row>
        </CardMenuTop>

        <CardBot>
          {tables && tables.length > 0 && (
            <GridItems
              items={tables}
              topDistance={topDistance}
              moveTable={(id, left, top, state) =>
                moveTable(id, left, top, state)
              }
              selectItem={selectItem}
              selectedPlace={selectedPlace}
              selectedSeparator={selectedSeparator}
              objects={objects}
            />
          )}
        </CardBot>
      </StyledCard>

      <Modal
        show={showCreateTables}
        onHide={() => setShowCreateTables(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Adicionar mesas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="numTablesToAdd">
              <Form.Label>Número de mesas a adicionar</Form.Label>
              <Form.Control
                type="number"
                min={1}
                value={numTablesToAdd}
                onChange={(e) => setNumTablesToAdd(e.target.value)}
                placeholder="Ex.: 6"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="numSeatsPerTable">
              <Form.Label>Número de lugares por mesa</Form.Label>
              <Form.Control
                type="number"
                min={1}
                value={numSeatsPerTable}
                onChange={(e) => setNumSeatsPerTable(e.target.value)}
                placeholder="Ex.: 4"
              />
            </Form.Group>

            <div style={{ fontSize: "0.85rem", color: "#666" }}>
              Posteriormente podes alterar o número de lugares de cada mesa no
              botão "Editar mesas".
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCreateTables(false)}
            disabled={isCreating}
          >
            Cancelar
          </Button>
          <OrangeButton
            onClick={handleCreateTables}
            disabled={!canCreate || isCreating}
          >
            {isCreating ? "A criar…" : "Guardar"}
          </OrangeButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteTables}
        onHide={() => setShowDeleteTables(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar mesas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2" style={{ fontSize: "0.9rem", color: "#555" }}>
            Sala selecionada:{" "}
            <b>
              {zones.find((z) => z.id === selectedPlace)?.place_of_table || "-"}
            </b>
            <br />
            Mesas actuais nesta sala:{" "}
            <b>
              {
                (tables || []).filter((t) => t.place_of_table === selectedPlace)
                  .length
              }
            </b>
          </div>
          <Form>
            <Form.Group className="mb-3" controlId="numTablesToDelete">
              <Form.Label>Número de mesas a eliminar</Form.Label>
              <Form.Control
                type="number"
                min={1}
                value={numTablesToDelete}
                onChange={(e) => setNumTablesToDelete(e.target.value)}
                placeholder="Ex.: 1"
              />
              <Form.Text muted>
                Serão removidas as últimas N mesas da sala.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteTables(false)}
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteTables}
            disabled={
              isDeleting ||
              !restaurants?.id ||
              !selectedPlace ||
              !Number(numTablesToDelete) ||
              Number(numTablesToDelete) < 1
            }
          >
            {isDeleting ? "A eliminar…" : "Eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCreateZone}
        onHide={() => setShowCreateZone(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Nova sala</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="zoneName">
              <Form.Label>Nome da sala</Form.Label>
              <Form.Control
                type="text"
                value={zoneName}
                onChange={(e) => setZoneName(e.target.value)}
                placeholder="Ex.: Sala Principal"
              />
            </Form.Group>
            <div style={{ fontSize: "0.85rem", color: "#666", marginTop: 8 }}>
              Será criada uma nova sala para este restaurante.
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCreateZone(false)}
            disabled={isCreatingZone}
          >
            Cancelar
          </Button>
          <OrangeButton
            onClick={handleCreateZone}
            disabled={isCreatingZone || !zoneName.trim()}
          >
            {isCreatingZone ? "A criar…" : "Guardar"}
          </OrangeButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteZone}
        onHide={() => setShowDeleteZone(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar sala</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ fontSize: "0.95rem" }}>
            Tem a certeza que pretende eliminar a sala{" "}
            <b>
              {zones.find((z) => z.id === selectedPlace)?.place_of_table || "-"}
            </b>
            ?
            <br />
            Mesas nesta sala:{" "}
            <b>
              {
                (tables || []).filter((t) => t.place_of_table === selectedPlace)
                  .length
              }
            </b>
          </div>
          <div style={{ fontSize: "0.85rem", color: "#666", marginTop: 8 }}>
            Esta ação não pode ser desfeita.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteZone(false)}
            disabled={isDeletingZone}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteZone}
            disabled={isDeletingZone || !selectedPlace}
          >
            {isDeletingZone ? "A eliminar…" : "Eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showBulkEditor}
        onHide={requestCloseBulkEditor}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar lista de mesas</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              marginBottom: 12,
              display: "grid",
              gridTemplateColumns: "minmax(220px, 320px) minmax(260px, 1fr)",
              gap: 14,
              alignItems: "start",
            }}
          >
            <Form.Group controlId="bulkEditRoom" style={{ margin: 0 }}>
              <Form.Label>Sala</Form.Label>
              <Form.Select
                value={bulkEditPlace || ""}
                onChange={(e) => changeBulkRoom(parseInt(e.target.value, 10))}
              >
                {zones.map((z) => (
                  <option key={z.id} value={z.id}>
                    {z.place_of_table}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="tableAssignmentMode" style={{ margin: 0 }}>
              <Form.Label>Modo de atribuição automática</Form.Label>
              <Form.Select
                value={draftAutoSetTables ? "flexible" : "fixed"}
                onChange={(e) =>
                  setDraftAutoSetTables(e.target.value === "flexible")
                }
              >
                <option value="flexible">Automático flexível</option>
                <option value="fixed">Grupos de mesas fixos</option>
              </Form.Select>

              <div style={{ fontSize: "0.82rem", color: "#666", marginTop: 6 }}>
                {draftAutoSetTables
                  ? "O sistema pode combinar quaisquer mesas livres para encontrar a melhor opção."
                  : "O sistema só usa mesas individuais ou grupos de mesas configurados."}
              </div>
            </Form.Group>
          </div>

          <div
            style={{
              marginBottom: 12,
              padding: "10px 12px",
              background: "#faf6e9",
              border: "1px solid #eee",
              borderRadius: 8,
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div>
              <div style={{ fontWeight: 700 }}>Grupos de mesas</div>
              <div style={{ fontSize: "0.85rem", color: "#666" }}>
                {isConnectionConfigMode && selectedItem?.id
                  ? `A configurar junções da mesa ${
                      selectedItem.table_name || selectedItem.table_number
                    }`
                  : draftAutoSetTables
                    ? "As junções ficam guardadas, mas só são usadas quando escolheres Grupos de mesas fixos."
                    : "Consulta as junções atuais ou configura os grupos de mesas fixos."}
              </div>
            </div>

            {!isConnectionConfigMode ? (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleStartGroupConfig}
                disabled={!bulkRows.length}
              >
                Configurar grupos de mesas
              </Button>
            ) : (
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Form.Select
                  size="sm"
                  value={selectedItem?.id || ""}
                  onChange={(e) => {
                    const table = bulkRows.find(
                      (row) => Number(row.id) === Number(e.target.value),
                    );

                    if (table) startEditingConnections(table);
                  }}
                >
                  {bulkRows.map((row) => (
                    <option key={row.id} value={row.id}>
                      Mesa {row.table_number || row.table_name || row.id}
                    </option>
                  ))}
                </Form.Select>

                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    setIsConnectionConfigMode(false);
                    setSelectedItem(null);
                    setSelectedConnectionIds([]);
                  }}
                >
                  Terminar configuração
                </Button>
              </div>
            )}
          </div>

          <BulkTableScroll>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "minmax(60px, 90px) 1fr 130px 130px 170px 90px",
                gap: 10,
                fontWeight: 700,
                padding: "6px 8px",
                borderBottom: "1px solid #e9ecef",
                background: "#fafafa",
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                minWidth: 900,
              }}
              role="row"
              aria-label="Cabeçalhos da lista de mesas"
            >
              <div>Mesa</div>
              <div>Nome da mesa</div>
              <div>Lugares</div>
              <div>Formato</div>
              <div>Junções</div>
              <div>Eliminar mesa</div>
            </div>

            {bulkRows.length === 0 ? (
              <div
                style={{
                  color: "#666",
                  padding: "10px 8px",
                  border: "1px solid #eee",
                  borderTop: "none",
                  borderRadius: "0 0 6px 6px",
                  minWidth: 900,
                }}
              >
                Sem mesas nesta sala.
              </div>
            ) : (
              <div
                style={{
                  maxHeight: 420,
                  overflowY: "auto",
                  border: "1px solid #eee",
                  borderTop: "none",
                  borderRadius: "0 0 6px 6px",
                  padding: 8,
                  minWidth: 900,
                }}
                role="table"
                aria-label="Lista de mesas editáveis"
              >
                {bulkRows.map((row) => (
                  <div
                    key={row.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "minmax(60px, 90px) 1fr 130px 130px 170px 90px",
                      gap: 10,
                      alignItems: "center",
                      padding: "6px 8px",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                    role="row"
                  >
                    <div style={{ fontWeight: 600 }}>
                      {row.table_number || "-"}
                    </div>

                    <Form.Group style={{ margin: 0 }}>
                      <Form.Label visuallyHidden>Nome</Form.Label>
                      <Form.Control
                        type="text"
                        value={row.table_name || ""}
                        onChange={(e) =>
                          onBulkRowChange(row.id, "table_name", e.target.value)
                        }
                        placeholder="Nome da mesa"
                        aria-label={`Nome da mesa ${row.table_number || ""}`}
                      />
                    </Form.Group>

                    <Form.Group style={{ margin: 0 }}>
                      <Form.Label visuallyHidden>Lugares</Form.Label>
                      <Form.Control
                        type="number"
                        min={1}
                        value={row.number_of_seats ?? ""}
                        onChange={(e) =>
                          onBulkRowChange(
                            row.id,
                            "number_of_seats",
                            e.target.value,
                          )
                        }
                        placeholder="Lugares"
                        aria-label={`Lugares da mesa ${row.table_number || ""}`}
                      />
                    </Form.Group>

                    <Form.Group style={{ margin: 0 }}>
                      <Form.Label visuallyHidden>Formato</Form.Label>
                      <Form.Select
                        value={row.round_or_square || "square"}
                        onChange={(e) =>
                          onBulkRowChange(
                            row.id,
                            "round_or_square",
                            e.target.value,
                          )
                        }
                        aria-label={`Formato da mesa ${row.table_number || ""}`}
                      >
                        <option value="square">Quadrada</option>
                        <option value="round">Redonda</option>
                      </Form.Select>
                    </Form.Group>

                    <div style={{ fontSize: "0.85rem" }}>
                      {!isConnectionConfigMode ? (
                        <span>{getConnectedTableNames(row.id)}</span>
                      ) : selectedItem?.id === row.id ? (
                        <span style={{ color: "#999", fontWeight: 600 }}>
                          Mesa atual
                        </span>
                      ) : selectedItem?.id ? (
                        <>
                          <Form.Check
                            type="checkbox"
                            label="Pode juntar"
                            checked={selectedConnectionIds.includes(row.id)}
                            onChange={() => toggleConnectionTable(row.id)}
                          />

                          <Button
                            variant="link"
                            size="sm"
                            style={{
                              padding: 0,
                              display: "block",
                              fontSize: "0.75rem",
                            }}
                            onClick={() => startEditingConnections(row)}
                          >
                            editar esta
                          </Button>
                        </>
                      ) : (
                        <span style={{ color: "#999" }}>Escolhe uma mesa</span>
                      )}
                    </div>

                    <div>
                      <CloseIcon
                        style={{
                          color: "#99b0ad",
                          right: "0",
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setConfirmDelete({
                            show: true,
                            tableId: row.id,
                            label:
                              row.table_number ||
                              row.table_name ||
                              `#${row.id}`,
                          })
                        }
                      />
                    </div>
                  </div>
                ))}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: 10,
                  }}
                >
                  <AddFilterBox
                    type="button"
                    onClick={() => setShowCreateTables(true)}
                    aria-label="Adicionar mesas"
                    title="Adicionar mesas"
                  >
                    <span style={{ fontSize: 18, lineHeight: "18px" }}>＋</span>
                    <span>Adicionar mesas</span>
                  </AddFilterBox>
                </div>
              </div>
            )}
          </BulkTableScroll>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={requestCloseBulkEditor}
            disabled={isBulkEditorSaving}
          >
            Cancelar
          </Button>

          <OrangeButton
            onClick={() => saveBulkEditor({ closeAfterSave: true })}
            disabled={
              isBulkEditorSaving || !bulkRows.length || !userInfo?.token
            }
            title="Guardar alterações"
          >
            {isBulkEditorSaving ? "A guardar…" : "Guardar alterações"}
          </OrangeButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUnsavedChangesModal}
        onHide={() => setShowUnsavedChangesModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Guardar alterações?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Existem alterações por guardar na lista de mesas, no modo de
          atribuição ou nos grupos de mesas. Queres guardar antes de sair?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowUnsavedChangesModal(false)}
            disabled={isBulkEditorSaving}
          >
            Continuar edição
          </Button>

          <Button
            variant="outline-danger"
            onClick={forceCloseBulkEditor}
            disabled={isBulkEditorSaving}
          >
            Sair sem guardar
          </Button>

          <OrangeButton
            onClick={() => saveBulkEditor({ closeAfterSave: true })}
            disabled={isBulkEditorSaving}
          >
            {isBulkEditorSaving ? "A guardar…" : "Guardar e sair"}
          </OrangeButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmDelete.show}
        onHide={() =>
          setConfirmDelete({ show: false, tableId: null, label: "" })
        }
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar mesa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tens a certeza que pretendes eliminar esta mesa?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() =>
              setConfirmDelete({ show: false, tableId: null, label: "" })
            }
            disabled={deletingRowId === confirmDelete.tableId}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={async () => {
              if (!confirmDelete.tableId) return;

              await handleDeleteSingleTable(confirmDelete.tableId);

              setConfirmDelete({ show: false, tableId: null, label: "" });
            }}
            disabled={deletingRowId === confirmDelete.tableId}
          >
            {deletingRowId === confirmDelete.tableId
              ? "A eliminar…"
              : "Eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
